import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import OptimizeImagesService from 'services/OptimizeImages.service';
import LanguageService from 'services/Language.service';
import styles from './NewsListItemComponent.module.scss';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import { ANCHOR } from 'common/consts/common';

export default class NewsListItemComponent extends Component {
  static propTypes = {
    news: PropTypes.object.isRequired
  };

  currentLanguage = LanguageService.getLang();

  render() {
    const { className, news } = this.props;

    const style = {
      backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
        news.photo
      )})`
    };

    return (
      <div className={`${styles.NewsListItemComponent} ${className}`}>
        <Link
          to={`${ANCHOR.NEWS[this.currentLanguage]}/${news.category}/${
            news.slug
          }`}
          className={styles.ImageLink}
        >
          <div className={styles.Image} style={style} />
        </Link>

        <div className={styles.Content}>
          <Link
            to={`${ANCHOR.NEWS[this.currentLanguage]}/${news.category}/${
              news.slug
            }`}
          >
            <h3 className={styles.Title}>{news.title}</h3>
          </Link>
          <p className={styles.Date}>
            {moment(news.publicationDate).format('LL')}
          </p>
          <div>
            {news.companies.map(company => (
              <img
                key={company.id}
                src={OptimizeImagesService.adjustImageSize(company.logo)}
                alt={company.name}
                className={styles.Logo}
              />
            ))}
          </div>
          <p className={styles.Description}>{news.intro}</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/News/components/NewsListItemComponent/NewsListItemComponent.js